type InteractionAction =
  | "page_viewed"
  | "field_focused"
  | "field_changed"
  | "scrolled_to_bottom"
  | "signature_drawn"
  | "camera_opened"
  | "file_selected"
  | "button_clicked"
  | "form_mutation"
  | "esign_consent.document_viewed"
  | "esign_consent.accepted";

interface Interaction {
  action: InteractionAction;
  target?: string;
  duration_ms?: number;
  client_ts: string;
}

const MAX_BUFFER_SIZE = 200;
const buffer: Interaction[] = [];

export function trackInteraction(
  action: InteractionAction,
  target?: string,
  duration_ms?: number,
): void {
  if (buffer.length >= MAX_BUFFER_SIZE) {
    return;
  }

  const interaction: Interaction = {
    action,
    client_ts: new Date().toISOString(),
  };

  if (target !== undefined) {
    interaction.target = target;
  }
  if (duration_ms !== undefined) {
    interaction.duration_ms = duration_ms;
  }

  buffer.push(interaction);
}

export function flushInteractions(): Interaction[] | undefined {
  if (buffer.length === 0) {
    return undefined;
  }
  return buffer.splice(0);
}
